import { memo, useContext } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import FaqSpotlight from "app/pages/Faq/FaqSpotlight/FaqSpotlight";
import "./FaqHome.scss";
import FaqHomeCategories from "app/pages/Faq/FaqHome/FaqHomeCategories/FaqHomeCategories";
import FaqFeaturedArticles from "app/pages/Faq/FaqHome/FaqFeaturedArticles/FaqFeaturedArticles";
import { Configure, InstantSearch } from "react-instantsearch-dom";
import AppGlobalsContext from "app/AppGlobalsContext";
import { ALGOLIA_FAQ_INDEX_NAME, searchClient } from "app/utils/algolia/searchClient";

const FaqHome = ({ faqCategories, faqSpotlight }) => {
	const { brand, shop } = useContext(AppGlobalsContext);
	return (
		<div className="faq-home">
			{!isEmpty(faqSpotlight) && (
				<div className="faq-home__spotlight">
					<FaqSpotlight
						articles={faqSpotlight.articles}
						message={faqSpotlight.message}
						title={faqSpotlight.title}
					/>
				</div>
			)}

			<div className="faq-home__nav">
				<FaqHomeCategories categories={faqCategories} />
			</div>

			<InstantSearch searchClient={searchClient} indexName={ALGOLIA_FAQ_INDEX_NAME}>
				<Configure filters={`brand:'${brand}' AND shop:'${shop}' AND featured:true`} />
				<FaqFeaturedArticles />
			</InstantSearch>
		</div>
	);
};

FaqHome.propTypes = {
	faqCategories: PropTypes.array,
	faqSpotlight: PropTypes.object,
};

FaqHome.defaultProps = {
	faqSpotlight: {},
};

export default memo(FaqHome);
